module.exports = __webpack_public_path__ + "media/components/KnowledgeBase/pages/KnowledgeBaseList/NoDataSource-54b291d0083b0ed4477e5a7f737ad454.png";